import * as React from 'react';
import { Id, Bem, printDevError, addClass } from '../../utils';
import { RadioGroupContextConsumer } from './RadioGroupContext';
import './RadioButton.css';
const bem = Bem.create('vai-radio-button');
export class RadioButton extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.label = React.createRef();
        this.state = { focused: false };
        this.renderWithContext = (context) => {
            const { label, state: { focused }, props: { htmlId, className, dataTa, disabled, children, onChange: propsOnChange, value, ...rest }, } = this;
            const id = Id.create(htmlId, ['radio button']);
            const checked = RadioButton.isChecked(context, this.props);
            const onChange = propsOnChange || context.onChange;
            return (React.createElement("div", { id: id.toString(), "data-ta": dataTa, className: addClass(bem.block(), className) },
                React.createElement("label", { className: bem.element('label')(checked && 'checked', disabled && 'disabled', focused && 'focused'), ref: label, tabIndex: -1, onFocus: this.onFocus, onBlur: this.onBlur },
                    React.createElement(RadioButton.Thumb, null),
                    React.createElement("input", Object.assign({}, rest, { id: id.copyWith(['input']).toString(), className: bem.element('input')(checked && 'checked', disabled && 'disabled'), type: "radio", disabled: disabled, onChange: onChange, tabIndex: checked && !disabled ? 0 : -1, value: value, checked: checked })),
                    children)));
        };
        this.onFocus = () => this.setState({ focused: true });
        this.onBlur = (e) => {
            const { current } = this.label;
            try {
                if (!current.contains(e.relatedTarget)) {
                    this.setState({ focused: false });
                }
            }
            catch (e) {
                printDevError(`RadioButton onBlur error: ${e.toString()}
            This is probably caused by a bug in @vaisala-rockhopper/components library`);
            }
        };
    }
    render() {
        return React.createElement(RadioGroupContextConsumer, null, this.renderWithContext);
    }
    static isChecked(context, props) {
        return (context.value !== undefined && context.value === props.value) || !!props.checked;
    }
}
RadioButton.metaProperties = ['disabled'];
RadioButton.Thumb = () => (React.createElement("svg", { className: "vai-radio-thump", height: "15", width: "15", tabIndex: -1, key: Math.random() },
    React.createElement("circle", { cx: "7.5", cy: "7.5", r: "7", className: "vai-radio-thump__outer" }),
    React.createElement("circle", { cx: "7.5", cy: "7.5", r: "4", className: "vai-radio-thump__inner" })));
//# sourceMappingURL=RadioButton.js.map